export enum LoadingTypeEnum {
    Partial = 0,
    Full = 1
}
